<script setup>

import CalendarWeeklySelector from "./selectors/CalendarWeeklySelector.vue";

const slots = defineModel();
const emit = defineEmits(['changeView']);
const selectedWorker = defineModel('selectedWorker', { default: null });
const form = defineModel('form');

defineProps({
    slotHeight: {
        type: Number,
        default: 42
    },
    formType: String
})
</script>

<template>
    <calendar-weekly-selector @change-view="emit('changeView')" v-model:selected-worker="selectedWorker" :form-type="formType" v-model:form="form" :slotHeight="slotHeight" v-model="slots"></calendar-weekly-selector>
</template>

<style scoped lang="scss">

</style>
